import { useTheme } from '@mui/material/styles';

export const UserProfileStyles = () => {
  const theme = useTheme();

  return {
    '& .UserProfile__avatar': {
      alignItems: "center",
      display: "flex",
      textDecoration: "none",
      paddingLeft: "12px",
    },
    '& .UserProfile__name': {
      marginLeft: "12px",
      color: theme.palette.primary.light,
      fontWeight: 500,
      marginRight: "84px",
      textTransform: "capitalize",
    },
    '& .UserProfile__missing-avatar': {
      alignItems: "center",
      borderRadius: "50%",
      backgroundColor: "#cecece",
      color: "white",
      display: "flex",
      fontWeight: "bold",
      justifyContent: "center",
      height: "40px",
      width: "40px",
    },
  }
}
